/*
 * @Author: zhouyx
 * @Date: 2023-08-08 14:26:49
 * @LastEditTime: 2023-08-08 14:34:38
 * @LastEditors: zhouyx
 * @FilePath: \长春市民卡h5-s\src\assets\js\rem.js
 * @程序猿: 佛祖保佑     永不宕机     永无BUG
 */
(function(doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function() {
      let clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if (clientWidth >= 750) {
        docEl.style.fontSize = "100px";
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
      }
    };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/assets/js/rem.js